import React from 'react';
import { fetchMonthlyTransactionReports } from 'apiRequest/transactionReport';
import TransactionReportPageContainer from 'components/TransactionReportPageContainer';

export default function TransactionReportMontly() {
  return (
    <TransactionReportPageContainer fetch={fetchMonthlyTransactionReports} />
  );
};
